import '.aw{max-width:77.5rem;}.ssr-plugin'
import { PropsWithChildren, FC } from 'react'
import { Style, styled } from 'inlines'
import useMediaQuery from '@app/util/useMediaQuery'

interface ResponsiveContainerProps extends PropsWithChildren {
    style?: Style
}

export const ResponsiveContainer: FC<ResponsiveContainerProps> = ({ children, style }) => {
    const isMobile = useMediaQuery()

    return (
        <styled.div className="aw"
            style={{
                width: isMobile ? '100%' : '85%',
                paddingInline: isMobile ? '1rem' : 0,
                ...style,
            }}
        >
            {children}
        </styled.div>
    )
}
